/**
 * Streaming enhanced Netflix Disney Prime Video — streaming-site enhancer
 *
 * Declares six web-accessible-resource entries, one per streaming service, each
 * exposing a small set of scripts (no `use_dynamic_url`) but scoped to that service's
 * origins. The Crunchyroll entry matches crunchyroll.com and exposes
 * `crunchyroll.ts.js` — static and fetchable at a fixed URL, but only from Crunchyroll.
 *
 * We probe from `https://www.crunchyroll.com` for the vendor-named `crunchyroll.ts.js`.
 * (`chunk-QIZ4XBKF.js` is also exposed but build-hashed, so it is avoided.)
 *
 * Manifest verified against version 1.1.99.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'akaimhgappllmlkadblbdknhbfghdgle';

export const streamingEnhanced: ExtensionDefinition = {
  id: ID,
  name: 'Streaming enhanced Netflix Disney Prime Video',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 40_000,
  requiredOrigin: 'https://www.crunchyroll.com',
  notes:
    'Per-service WAR entries scoped to each streaming origin, no dynamic URL. The ' +
    'Crunchyroll-scoped crunchyroll.ts.js is conclusive from crunchyroll.com only.',
  signals: [
    {
      id: 'war-crunchyroll-ts-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch crunchyroll.ts.js — a service-named script, static but only exposed to ' +
        'crunchyroll.com origins.',
      weight: 1,
      run: () => probeFetch(ID, 'crunchyroll.ts.js'),
    },
    {
      id: 'war-shared-functions-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch shared-functions.js — a stable, vendor-named script exposed alongside ' +
        'the Crunchyroll entry, corroborating the identification.',
      weight: 0.5,
      run: () => probeFetch(ID, 'shared-functions.js'),
    },
  ],
};
